export default __webpack_public_path__ + "static/media/giftBox.f2ff0ce3.svg";